import { Scale } from "@pdfking/math"

import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { Area } from "../Area"
import { PictureCover } from "../PictureCover"
import { Region } from "../Region"

/** Hamurz, a landscape desk calendar: the year up the left of its picture; a month's band in the primary on its left, the logo and the contact on it, its name over its grid right of it. */
export const Hamurz: CalendarDesign = {
  cover: PictureCover({ vertical: true }),
  page: ({ gap, language, outer, page, short, year }, month) => {
    const band = Region(page, 0, 0, 0.3, 1)
    return [
      Area.solid(band),
      Area.contact(Slice.before(outer, band.width, gap), false, true),
      ...Area.month(
        Slice.after(outer, band.width, gap),
        month,
        year,
        language,
        Scale(short, 0.08),
        gap
      ),
    ]
  },
  pages: "month",
}
